module.exports = __webpack_public_path__ + "static/media/mercury.f60b4f84.svg";